module.exports = __webpack_public_path__ + "static/WEDDING E&M-191-80d1772d8cbcd266de3e70c44e175ca8.jpg";